import Grid from "../widgets/grid/grid.vue";
import NewForm from '../forms/newform/newForm.vue';
import Helper from '../../assets/ts/helper';

const helper = new Helper();

export default {
    data() {
        return {
            direction: payload.currentLocale.IsRightToLeft,
            columns: [
                { field: "ID", title: i18n.$t("logs_management.error_number"), menu: false, hidden: false },
                { field: "DateTime", title: i18n.$t("logs_management.date"), menu: false, hidden: false, template: (data) => helper.formatDateTime(new Date(data.DateTime)) },
                { field: "LogLevel", title: i18n.$t("logs_management.level"), menu: false, hidden: true },
                { field: "UserID", title: "UserID", menu: false, hidden: true },
                { field: "TaskID", title: "TaskID", menu: false, hidden: true },
                { field: "FormID", title: "FormID", menu: false, hidden: true },
                { field: "IP", title: "IP", menu: false, hidden: true },
                { field: "IPV6", title: "IPV6", menu: false, hidden: true },
                { field: "ProxiedIP", title: "ProxiedIP", menu: false, hidden: true },
                { field: "ProxiedIPV6", title: "ProxiedIPV6", menu: false, hidden: true },
                { field: "StaffID", title: i18n.$t("logs_management.staff_id"), menu: false, hidden: true },
                { field: "DomainObjectID", title: "DomainObjectID", menu: false, hidden: true },
                { field: "FormBehaviorID", title: "FormBehaviorID", menu: false, hidden: true },
                { field: "Info", title: "Info", menu: false, hidden: true },
                { field: "ApplicationName", title: i18n.$t("logs_management.application_name"), menu: false, hidden: false },
            ],
            detailConfig: this.detailConfigFn
        }
    },
    methods: {
        detailConfigFn(e) {
            let dataItem = e.data;
            e.detailRow.children('td.k-detail-cell').css({ direction: "ltr", textAlign: "left" }).html(dataItem.Info);
        },
        showDetailToUser() {
            let checkbox = $(this.$el).find('#cbxShowErrorDetails');
            this.doAjaxRequest("api/bpmslogs/changeShowLogDetail",
                {
                    showLogDetail: checkbox.prop('checked')
                },
                null,
                null,
                "GET");
        },
        doAjaxRequest(url, data, onSuccess, onFailure, method) {
            let ajaxConfig = {
                url: url,
                data: data,
                dataType: "json",
                contentType: "application/json;charset=utf-8"
            };

            ajaxConfig.beforeSend = (xhr) => {
                xhr.setRequestHeader("__RequestVerificationToken", $("[name='__RequestVerificationToken']").val());
            };

            if (method) {
                ajaxConfig.method = method;
            }
            $.ajax(ajaxConfig)
                .done((result) => {
                    if (typeof onSuccess === 'function')
                        onSuccess(result);
                }).error((error) => {
                    console.log(error);
                    if (typeof onFailure === 'function')
                        onFailure();
                });
        }
    },
    updated() {
    },
    mounted() {
        console.log("a", this);
        this.doAjaxRequest("api/BPMSLogs/GetShowLogDetailValue",
            {}, (data) => {
                let checkbox = $(this.$el).find('#cbxShowErrorDetails');
                checkbox.prop('checked', data);
            });
    },
    components: {
        Grid,
        NewForm
    }
}
